import * as R from 'ramda'

export const matchNumberOr =
  defaultValue =>
    R.tryCatch(
      Number,
      R.always(defaultValue),
    )

export const range = R.curry(
  (start, end) =>
    Array.from(
      { length: end - start },
      (__, index) => start + index,
    )
)
